export default {
  Tips_Common: {
    Changes_Clinic_Settings: 'Save changes to clinic treatment settings?',
    Cntrols_Successfully: 'Successful operation',
    Input_Promotion_Name: 'Input Name',
    Input_Promotion_Code: 'Input Code',
    reset_successfully: 'Reset successfully',
    edit_successfully: 'Modified successfully',
    add_successfully: 'Add successfully',
    complete_certificate: 'Complete the certificate list',
    has_confirm_shutdown: 'Data has been modified. Confirm shutdown?',
    enter_account: 'Enter account',
    must_account_less: 'Account cannot be less than 6',
    must_account_than: 'Account cannot exceed 20',
    must_account_fomat:
      'Contain Uppercase, Lowercase, Number, Special characters(_-@.)',
    format_error: 'Input format error',
    enter_id: 'Enter your ID number',
    must_id_less: 'ID number must be at least 6 characters',
    perfect_source: 'Complete source',
    file_format_incorrect: 'Please upload the file in jpeg, png or pdf format',
    enter_name: 'Enter name',
    enter_phone: 'Enter phone',
    select_birth: 'Select birth',
    select_sex: 'Select sex',
    select_scheduling: 'Select scheduling',
    enter_describe: 'Enter describe',
    select_cert_type: 'Select type',
    enter_certificate_numb: 'Enter number',
    enter_certificate_title: 'Enter title',
    select_issue_date: 'Select issue date',
    upload_attachment: 'Upload the attachment',
    search_menu: 'Search Menu',
    full_screen: 'Full screen',
    full_screen_out: 'Exit full screen',
    content_recovery: 'Content recovery',
    content_enlargement: 'Content enlargement',
    content_full_screen: 'Content full screen',
    deleting_role: 'Deleting a role',
    confirm_deletion: 'Confirm deletion',
    del_successfully: 'Delete successfully',
    input_bag_time: 'Input',
    input_g_bag: 'Input',
    bag_time_need: 'non-zero',
    g_bag_need: 'non-zero',
    method_need: 'Select at least one method',
    postage_need: 'Enter the postage',
    cannot_null: 'Cannot be null',
    end_equal_start:
      'End of the scale setting must be equal to the start of the next stage',
    config_save_no: 'Save or not',
    save_successfully: 'Save successfully',
    err_network: 'Err Network',
    loading: 'Loading',
    discount_example: '80% = 20% off',
    denomination_need: 'Enter denomination',
    discount_need: 'Enter discount',
    enter_coupon_name: 'Enter coupon name',
    select_is_coupon: 'Select subscriber or not',
    select_coupon_type: 'Select coupon type',
    select_is_enable: 'Select enable or not',
    enter_amount: 'Enter amount',
    select_scope_use: 'Select scope use',
    denomination_less_amount: 'Denomination must be less than full deduction',
    deleting_project: 'Deleting a coupon',
    attachment_load: 'Attachment uploaded, please wait',
    information_backfill:
      'The current ID number has user information, whether to backfill',
    cannot_activated:
      'The drug has been disabled by the platform and cannot be operated',
    select_address: 'Select address information',
    tips_address: 'Length should be 2-120, and cannot contain emoticons',
    use_default: 'Confirm whether to use the default address',
    enter_pingyin: 'Enter Chinese or Pinyin',
    enter_code: 'Enter code',
    enter_price: 'Enter price',
    enter_min_whole: 'Enter minimum warning quantity',
    enter_max_whole: 'Enter maximum warning quantity',
    complete_order: 'Complete the current order',
    order_completed: 'Order completed',
    cancel_successfully: 'Cancel successfully',
    no_record: 'No record of receipt',
    no_data: 'No data',
    enter_opinion: 'Enter opinion',
    audit_completed: 'Audit completed',
    enter_description: 'Enter project description',
    cannot_empty: 'Order cannot be empty',
    submit_successfully: 'Submit successfully',
    clear_order_list: 'Confirm to clear the order list',
    temporary_successfully: 'Temporary successfully',
    bring_quantity: 'Bring in the order quantity',
    least_one_drug: 'Sign for at least one drug',
    confirm_receipt: 'Confirm the receipt of the order',
    continue_sign: 'Signatures is 0, whether to continue to sign',
    sign_successfully: 'Sign successfully',
    expired_continue_sign: 'Drug has expired, continue to sign for it?',
    sign_remaining_all: 'Sign for all remaining order quantity',
    invalid_barcode: 'Invalid barcode',
    not_onpurchase: 'Drugs are not on the purchase list',
    signings_not_exceed: 'Signings must not exceed the order data',
    whether_backfill: 'ID number has user information, whether to backfill',
    enter_prepaid_name: 'Enter name',
    select_level: 'Select level',
    enter_discount: 'Enter discount',
    enter_discount_zero: 'Discount no zero',
    enter_threshold: 'Enter threshold',
    deleting_card: 'Deleting',
    level_exists: 'Level already exists',
    starting_exists: 'Starting amount already exists',
    confirm_report: 'Confirm report',
    cntrols_successfully: 'Successful operation',
    no_standard: 'No standard',
    sign_first: 'Sign first',
    report_first: 'Report successfully',
    be_un_inequality: 'Unmatch',
    confirm_delete_group:
      'Deleting the current group will also delete the associated charging rules and charge items. Are you sure you want to delete',
    confirm_delete_rule:
      'Deleting the current rule will also delete the associated charge items. Are you sure you want to delete',
    set_default: 'Confirm whether to use the default',
    use_price: 'The selling price of the drug is charged',
    use_cost: 'The cost of using the drug is charged',
    use_ticket: 'The selling price of the ticket is charged',
    use_fee: "Use the doctor's fee",
    edit_print: 'Print configuration is being edited. Save changes',
    pay_modify: 'Preset mode locks fee information',
    enter: 'Enter',
    sku_exists: 'The medicine already exists',
    complete_dosage: 'Please complete the dosage of the medicine',
    acupoint_exists: 'Already exists',
    drug_detail: 'Details (Herb)',
    confirm_syncing: 'Confirm syncing drug information to the current product',
    empty_no: ' is null',
    prefix_repeat: 'Prefix repeat',
    un_down_data: 'No data is currently available for download',
    complete_rule: 'Complete rule',
    input_name_code: 'Input name or code',
    input_name_code_phone: 'Input I.D. No. name or phone',
    input_code_name_phone: 'Input I.D. No. name or phone',
    input_name_en: 'Input name in Chinese or English',
    birthday_out: 'The date of birth cannot be later than today',
    electronic_empty: 'The electronic scale setting value cannot be empty',
    start_next:
      'The end value of the electronic scale setting must equal the start value of the next stage',
    input_type: 'Input name',
    source_get_tips1:
      '* A new number source will be generated. Please confirm whether to overwrite the existing one.',
    source_get_tips2:
      'Overwritten: Generation will start from the following day.',
    source_get_tips3:
      'Not overwritten: Generation will start from the day after the last number source was created.',
    no_chinese_id: 'No Chinese characters in ID number.',
    complete_certificate_list: 'Please complete the certificate list!',
    openTime_closeTime_no: 'Business hours cannot be empty!',
    openTime_closeTime_before: 'Closing time must be after opening time!',
    openTime_pre_closeTime_after:
      'Start time must be after the end time of the previous period!',
    days_cannot_empty: 'Days cannot be empty.',
    frequency_cannot_empty: 'Daily frequency cannot be empty.',
    confirm_delete: 'Delete?',
    QueRen_BaoCun: 'Save?',
    ChuFang_ChaoGuo: 'Prescription count exceeds two, continue applying?',
  },
}
